import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CAL_PARTNERS_BOOKING_URL, EMAIL_SALES } from '@app/config';
import { TuiButton } from '@taiga-ui/core';
import { RoughNotationModule } from 'ng-rough-notation';

@Component({
  selector: 'app-partners-hero-section',
  imports: [RoughNotationModule, TuiButton],
  templateUrl: './partners-hero-section.component.html',
  styleUrl: './partners-hero-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PartnersHeroSectionComponent {
  protected readonly emailSales = EMAIL_SALES;
  protected readonly bookingUrl = CAL_PARTNERS_BOOKING_URL;
}
